/** Individually authored heads from the named male/female reference sheets.
 * `base` remains the original Heroic mesh. Retired numeric studies deliberately
 * resolve to Heroic when loading older saves. */
export const HEAD_CATALOG = {
  male: [
    { id: 'base', label: 'Heroic / Balanced', description: 'Balanced proportions, clear cheek planes and a steady gaze.' },
    { id: 'broad', label: 'Broad / Warm', description: 'A broad crown, full cheeks and a generous, rounded jaw.' },
    { id: 'sharp', label: 'Sharp / Intense', description: 'High cheekbones, narrow contours and focused eyes.' },
    { id: 'soft', label: 'Soft / Youthful', description: 'Rounded cheeks, gentle brows and a shorter chin.' },
    { id: 'rugged', label: 'Strong / Rugged', description: 'A square mandible, strong brow and broad chin.' },
    { id: 'elegant', label: 'Elegant / Refined', description: 'Slender contours, a fine nose and a calm gaze.' },
  ],
  female: [
    { id: 'base', label: 'Heroic / Balanced', description: 'Balanced proportions, almond eyes and a defined chin.' },
    { id: 'broad', label: 'Broad / Warm', description: 'A rounded crown, full cheeks and a wider, softer jaw.' },
    { id: 'sharp', label: 'Sharp / Intense', description: 'Angular cheekbones, a tapered chin and focused eyes.' },
    { id: 'soft', label: 'Soft / Youthful', description: 'Full cheeks, open eyes and a compact, rounded chin.' },
    { id: 'rugged', label: 'Strong / Rugged', description: 'A firm jaw, broad chin and defined cheek planes.' },
    { id: 'elegant', label: 'Elegant / Refined', description: 'A slender oval, delicate features and gently arched brows.' },
  ],
} as const;
export type FaceId = (typeof HEAD_CATALOG.female)[number]['id'];
export const PLAYER_HEAD_CATALOG = HEAD_CATALOG;
export function validateFaceId(raw: unknown, body?: string): FaceId {
  const choices = body === undefined || body === 'female' ? HEAD_CATALOG.female : HEAD_CATALOG.male;
  return choices.some(h => h.id === raw) ? raw as FaceId : 'base';
}
